module.exports = __webpack_public_path__ + "static/media/p208g1.eb85f804.jpg";